import React, { useEffect, useState } from "react";
import { viewApprovalLine } from "../../api/approval";
import * as designMeta from "../../api/design/meta";
import { getDocSignatureInfo } from "../../api/papers";

export default function SignatureCompactTable_dns({ dns, actor }) {
    const [creator, setCreator] = useState(null);
    const [lines, setLines] = useState([]);

    useEffect(() => {
        const load = async () => {
            try {
                const sig = await getDocSignatureInfo(dns);
                setCreator(sig.data || null);


                const res = await viewApprovalLine(dns);
                console.log(res)
                setLines(res.data?.approval_lines || []);
            } catch (err) {
                console.error("Signature fetch error:", err);
            }
        };

        load();
    }, [dns]);

    const approvals = lines
        .filter((l) => l.order !== 0)
        .sort((a, b) => a.order - b.order);

    function mapApprover(line, label) {
        if (!line) {
            return { label, name: "-", position: "", sign: null, state: "waiting" };
        }

        return {
            label,
            name: line.approver_name || "-",
            position: line.approver_position || "",
            sign: line.sign_file || null,
            state: line.is_approved,
        };
    }

    // 🔥 결재선이 2개 이상이면 마지막 두 개 사용
    const lastTwo = approvals.slice(-2);

    const reviewer = lastTwo[0] || null;
    const approver = lastTwo[1] || null;

    const cells = [
        actor
            ? actor
            : {
                label: "작성자",
                name: creator?.name || "-",
                position: creator?.position || "",
                state: "approved",
                sign: creator?.sign,
            },
        mapApprover(reviewer, "검토자"),
        mapApprover(approver, "승인자"),
    ];

    /* 🔥 여기서 싸인을 absolute로 빼버림 */
    function renderSignatureRow(c) {
        return (
            <div className="relative h-full flex items-center px-1">
                {/* 이름 (왼쪽) */}
                <span className="text-[11px] whitespace-nowrap z-10">{c.name}</span>

                {/* 싸인 (오른쪽 absolute) */}
                {c.sign && c.state === "approved" ? (
                    <img
                        src={c.sign}
                        alt="sign"
                        className="pointer-events-none select-none"
                        style={{
                            position: "absolute",
                            right: "2px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            height: "70px",
                            width: "120px",
                            objectFit: "contain",
                        }}
                    />
                ) : c.state === "approved" ? (
                    <span
                        className="text-green-600 text-lg leading-none absolute right-2"
                        style={{ top: "50%", transform: "translateY(-50%)" }}
                    >
                        ✓
                    </span>
                ) : c.state === "rejected" ? (
                    <span
                        className="text-red-600 text-lg leading-none absolute right-2"
                        style={{ top: "50%", transform: "translateY(-50%)" }}
                    >
                        ✗
                    </span>
                ) : (
                    <span
                        className="text-gray-400 text-sm leading-none absolute right-2"
                        style={{ top: "50%", transform: "translateY(-50%)" }}
                    >
                        미결
                    </span>
                )}
            </div>
        );
    }


    return (
        <table
            className="w-full border mt-4 text-[12px] text-center border-black"
            style={{ tableLayout: "fixed" }}
        >
            <thead className="doc-thead">
                <tr className="bg-gray-100">
                    {cells.map((c, i) => (
                        <th key={i} className="doc-th whitespace-pre-line">
                            {c.label}
                        </th>
                    ))}
                </tr>
            </thead>

            <tbody>
                <tr>
                    {cells.map((c, i) => (
                        <td
                            key={i}
                            className="border-r border-black align-middle"
                            style={{
                                height: "32px",   // 🔒 칸 높이 고정
                                maxHeight: "32px",
                                overflow: "visible",
                            }}
                        >
                            {/* 이 div 높이가 칸 높이 = 싸인은 absolute라 여기 높이에 안 영향 줌 */}
                            <div className="h-[32px] relative overflow-visible">
                                {renderSignatureRow(c)}
                            </div>
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    );
}
